import { Directive } from '@angular/core';
import { QuoteFacade } from '../+state/quote.facade';

@Directive()
export abstract class QuoteReportingBaseComponent extends QuoteFacade {
  constructor() {
    super();
  }
}
